import { render, staticRenderFns } from "./EnroolList.vue?vue&type=template&id=7c127985&scoped=true&"
import script from "./EnroolList.vue?vue&type=script&lang=js&"
export * from "./EnroolList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c127985",
  null
  
)

export default component.exports